<div class="col-lg-12">
    <div class="card ui-cards mt-3">
        <div class="card-body">
            <h5 class="mb-3">
                <b >
                    Bridge
                </b>
            </h5>
            <form [formGroup]="bridgeForm" (ngSubmit)="swap()">
                <div class="row">
                    <div class="col-md-5 col-5 pe-0">
                        <div class="input-group">
                            <img src="assets/images/binance.svg" alt="" height="25" width="20%" *ngIf="account.chainId == 97">
                            <img src="assets/images/ethereum.svg" alt="" height="25" width="20%" *ngIf="account.chainId != 97">
                            <label *ngIf="account.chainId == 97">Binance</label>
                             <label *ngIf="account.chainId != 97">Ethereum</label>
                        </div>
                    </div>
                    <div class="col-md-2 col-2 swap-aero">
                    <img src="assets/images/arrow.svg" alt="" height="40" (click)="changeNetwork(account.chainId == 17000 ? 97 : 17000)">
                        
                    </div>
                    <div class="col-md-5 col-5 ps-0">
                        <div class="input-group">
                            <label *ngIf="account.chainId == 97">Ethereum</label>
                            <label *ngIf="account.chainId != 97">Binance</label>
                            <img src="assets/images/ethereum.svg" alt="" height="25" width="20%" *ngIf="account.chainId == 97">
                            <img src="assets/images/binance.svg" alt="" height="25" width="20%" *ngIf="account.chainId != 97">
                        </div>
                    </div>
                    <div class="col-md-12 mt-3 mb-3">
                        <div class="input-group">
                            <div class="w-100 polka-amt">
                                <b class="text-polka">
                                    Enter To Address
                                </b>&nbsp;
                            </div>
                            <input type="text" class="form-control w-100" placeholder="0x...." formControlName="bridgeAddress" name="bridgeAddress" id="bridgeAddress">
                        </div>
                    </div>
                    <div class="col-md-12 mt-3 mb-3">
                        <div class="input-group">
                            <div class="w-100 polka-amt">
                                <b class="text-polka">
                                    Enter Amount
                                </b>&nbsp;
                                <button (click)="setMax()" class="btn btn-outline-secondary max-btn" type="button" id="button-addon3">MAX</button>
                            </div>
                            <input type="number" class="form-control" min="0"   placeholder="0.0" formControlName="bridgeAmount" name="bridgeAmount" id="bridgeAmount">
                        </div>
                    </div>
                </div>
                <div class="">
                    <button type="submit" [disabled]="isLoading" *ngIf="account.address && isSupportNetwork" class="btn btn-polka w-100 d-flex justify-content-center">
                        <div *ngIf="isLoading" class="loader"> </div> <span *ngIf="!isLoading" > Swap </span>
                        <span *ngIf="isLoading">&nbsp;Swapping... Please wait!</span>
                    </button>
                    </div>
                    </form>
                <button class="btn btn-polka w-100 d-flex justify-content-center" *ngIf="!account.address" (click)="connectWallet()"> Connect Wallet </button>
                <button class="btn btn-polka w-100 d-flex justify-content-center" *ngIf="account.address && !isSupportNetwork" data-bs-toggle="modal" data-bs-target="#switchNetwork"> Wrong Network </button>
        </div> 
        <app-bridge-transactions [migrateTransactions]="migrationTransactions"></app-bridge-transactions>
    </div>
</div>


<!-- Modal -->
<div class="modal fade" id="switchNetwork" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="switchNetworkLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="switchNetworkLabel">Switch network</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" #switchNetworkModalClose></button>
        </div>
        <div class="modal-body d-flex justify-content-evenly">
            <button class="btn btn-polka d-flex justify-content-center" (click)="changeNetwork(17000)"> Switch to Ethereum </button>
            <button class="btn btn-polka d-flex justify-content-center" (click)="changeNetwork(97)"> Switch to Binance </button>
        </div>
      </div>
    </div>
  </div>